
import React from 'react'
import { Form } from 'react-bootstrap'

import useTranslation from '../../../Hooks/UseTranslation'

import WorksList from '../components/WorksList'

const TaskWorks = ({ items }: any) => {

  const { t } = useTranslation()

  return (
    <Form>
      <Form.Group>
        <Form.Label>
          {t('PROGRAMMATION_MANAGER:WorksLabel')}
        </Form.Label>
        <WorksList
          items={items}
        />
      </Form.Group>
    </Form>
  )
}

export default TaskWorks
